import ApiResponse from '@/models/ApiResponse'

import { get } from '../axios'

export interface VrNetworkList {
  id: number
  full_name: string | null
  phone_number: string
  auth_id: string
  photo_S3_path: string | null
  profile: {
    village: string | null
    block: string | null
    district: string | null
    state: string | null
  }
}

const fetchVrNetwork = async (url: string) => {
  return await get<ApiResponse<VrNetworkList>>(url)
}

export default fetchVrNetwork
